module.exports = __webpack_public_path__ + "img/atendimento-ao-turista.png";